<template>
  <div class="contest-auth">
    <Tabs v-model="tab" class="contest-auth__tabs" hide-slider>
      <Tab href="#signin">Вход</Tab>
      <Tab href="#signup">Регистрация</Tab>
      <!-- <Tab href="#restore"></Tab> -->
    </Tabs>
    <TabsItems v-model="tab" class="contest-auth__content">
      <TabItem value="signin">
        <Signin />
      </TabItem>
      <TabItem value="signup">
        <Signup />
      </TabItem>
      <!-- <TabItem value="restore">
        <PasswordRecover />
      </TabItem> -->
    </TabsItems>
  </div>
</template>

<script>
import { asyncModal } from "@/components/ui/modal/";
import { Tabs, TabsItems, Tab, TabItem } from "@/components/ui/tabs";
import Signin from "./Signin";
import Signup from "./Signup";
import PasswordRecover from "./PasswordRecover";

const ContestAuth = {
  name: "ContestAuth",
  components: {
    Signin,
    Signup,
    PasswordRecover,
    Tabs,
    TabsItems,
    Tab,
    TabItem
  },

  data() {
    return {
      tab: "signin"
    };
  }
};
export default ContestAuth;

export function openModal() {
  return asyncModal({
    name: "contest-auth-modal",
    component: ContestAuth
  });
}
</script>

<style lang="scss">
.contest-auth {
  width: 100%;
  overflow: hidden;
  border-radius: inherit;

  &__content {
    padding: 30px;

    @include breakpoint("xs-only") {
      padding: 16px;

      .btn {
        width: 100%;
      }
    }
  }

  &-modal {
    .modal-card {
      padding: 0;
      width: 100%;
    }
  }

  .form-fields {
    @include breakpoint("xs-only") {
      padding-top: 0 !important;
    }
  }
}
</style>
